import PendingRxList from "./PendingRxList";

export default PendingRxList;
